<template>
    <div class="menu-action no-select">
        <a href="/events">
            <i class="fa fa-calendar-alt tw-relative">
                <div class="notification-background hidden flex flex-no-padding">
                    <div class="notification-number flex-child-center notification-badge-wrapper"
                         style="margin-left: 2px;">
                        <p id="inbox-total" class="notification-badge" :data-notify-id="'events.total'"></p>
                    </div>
                </div>
            </i>
        </a>
    </div>
</template>

<script>
import Cookies from 'js-cookie';
import moment from 'moment';
import HuddleEvent from '@/resources/assets/js/vue/lib/models/Event';

export default {
    name: 'EventIcon',

    data() {
        return {
            todays_count: 0,
        };
    },

    methods: {
        fetchTodaysEvents() {
            const cookie = Cookies.get('events_shown');

            if (typeof cookie === 'undefined') {
                const params = new URLSearchParams();
                const today = moment(new Date).format('YYYY-MM-DD');

                params.append('where', `start_date:${today}`);

                HuddleEvent.api().fetch(params, 'discover', false).then((response) => {
                    this.todays_count = response.response.data.meta.total;
                });
            }
        },

        setCookie() {
            let tomorrow = new Date();

            tomorrow.setHours(0, 0, 0, 0);

            tomorrow.setDate(tomorrow.getDate() + 1);

            Cookies.set('events_shown', true, {
                expires: tomorrow,
            });
        },
    },

    mounted() {
        this.fetchTodaysEvents();
    },
};
</script>
